import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import cookieHelper from 'cookie';

// Contexts
import { withNavigation, withTranslate } from '../../../core/TenantProvider';
// Components - Atoms, Organisms,Containers
import APHeading from '../../atoms/APHeading';
import APLabel from '../../atoms/APLabel';
import APButton from '../../atoms/APButton';
// Files in the same folder
import GenericError from './assets/GenericError.svg';
import APRegistrationErrorStyle from './styles/APRegistrationError.style';
// Types
import { RoleAccessFunction } from '../../../core/types/AffiliateDetails';
// Utils
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
// Redux
import { ReducerState } from '../../../redux/modules';
import { actions as RegisterActions } from '../../../redux/modules/register';
// Constants
import { ORGANIZATION_CONTACT_NO_MAPPING, SSO_CDH_COMPANY_KEY } from '../../../core/utils/Constants/Constants';

const ssoReferringCompany: string = cookieHelper.parse(document.cookie)[SSO_CDH_COMPANY_KEY];
const referringCompany: string = ssoReferringCompany ?? cookieHelper.parse(document.cookie).cdhCompany;

interface APRegistrationErrorProps extends WithStyles<typeof APRegistrationErrorStyle> {
    translate: Function,
    navigate: any,
    updateRegisterCustomerStatus: Function,
    roleAccessFunction: RoleAccessFunction
}

class APRegistrationError extends Component<APRegistrationErrorProps, {}> {

    constructor(props) {
        super(props);

        this.onReturnHandler = this.onReturnHandler.bind(this);
        this.triggerGA = this.triggerGA.bind(this);
    }

    onReturnHandler() {
        this.props.navigate('/register_client');
        this.props.updateRegisterCustomerStatus();

        TriggerGoogleAnalyticsTag(
            GoogleAnalyticTags.eventAction.click,
            GoogleAnalyticTags.registerClient.click.contactYourPartnerManagerRegisterNewClientCtaClicked
        );

        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            GoogleAnalytics4Tags.eventAction.click,
            GoogleAnalytics4Tags.registerClient.click.clientRegistrationFailedNewCustomerCta
        );

    }

    triggerGA(route: string) {
        this.props.navigate(`/${route}`);

        TriggerGoogleAnalyticsTag(
            GoogleAnalyticTags.eventAction.click,
            GoogleAnalyticTags.registerClient.click.contactYourPartnerManagerBackToAccountCtaClicked
        );
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            GoogleAnalytics4Tags.eventAction.click,
            GoogleAnalytics4Tags.registerClient.click.clientRegistrationFailedBackToClientManagementCta
        );
    }

    componentDidMount() {
        TriggerGoogleAnalyticsTag(
            GoogleAnalyticTags.eventAction.load,
            GoogleAnalyticTags.registerClient.load.ContactYourPartnerManagerPageLoad
        );

        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.registerClient.name,
            GoogleAnalytics4Tags.eventAction.load,
            GoogleAnalytics4Tags.registerClient.load.clientRegistrationFailedPageLoad
        );
    }

    render() {

        const {
            classes,
            translate
        } = this.props;

        const portalNumber: string = ORGANIZATION_CONTACT_NO_MAPPING[referringCompany];

        return (
            <div className={classes.errorContainer}>
                <APHeading className={classes.header} variant="h4">
                    {translate('register.customer.error.heading')}
                </APHeading>
                <div className={classes.errorSection}>
                    <APHeading className={classes.errorHeader} variant="h4">
                        {translate('register.customer.error.subheading')}
                    </APHeading>
                    <APLabel className={classes.errorLabel}>
                        {translate('register.customer.error.message.part.one')}<span className={classes.link}>{portalNumber}</span>
                        {translate('register.customer.error.message.part.two')}
                    </APLabel>
                    <div className={classes.mainImage}>
                        <img src={GenericError} alt="Generic Error" />
                    </div>
                    <div className={classes.bodyContent}>

                    </div>
                </div>
                <div>
                    <div className={classes.buttonsRow}>
                        {/*to="/register_client"*/}
                        <APButton variant="outlined" onClick={this.onReturnHandler}>
                            {translate('register.customer.error.register.button')}
                        </APButton>
                        <APButton
                            color="primary"
                            variant="contained"
                            onClick={() => this.triggerGA('client_management')}
                        >
                            {translate('register.customer.error.clientmanagement.button')}
                        </APButton>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store: ReducerState) => ({
    roleAccessFunction: store.user.roleAccessFunction
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    updateRegisterCustomerStatus: RegisterActions.updateRegisterCustomerStatus,
}, dispatch);

export default withNavigation(withTranslate(withStyles(APRegistrationErrorStyle)(connect(mapStateToProps, mapDispatchToProps)(APRegistrationError))));